/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {CircularProgress, IconButton, InputAdornment, TextField} from "@mui/material";
import {Brightness1, SearchSharp} from "@mui/icons-material";
import {theme} from "../../Tema";


const IngresoTextoBoton = ({
                               props,
                               nombre,
                               dato,
                               lineas = 1,
                               Icono = Brightness1,
                               requerido = false,
                               size = 'small',
                               type = 'text',
                               editable = true,
                               click = () => {
                               },
                               cargando = false,
                               IconoFinal = SearchSharp
                           }) => {
    const {register, errors} = props

    return (
        <TextField
            slotProps={lineas <= 1 ? {
                    input: {
                        startAdornment: (

                            <InputAdornment position="start">
                                <Icono color={'primary'}/>
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    disabled={cargando}
                                    onClick={() => click()}
                                    sx={{
                                        backgroundColor: theme.palette.primary.main, borderRadius: 2,
                                        "&:hover": {
                                            backgroundColor: theme.palette.secondary.main
                                        }

                                    }}>
                                    {cargando ?
                                        <CircularProgress size={24}/>
                                        :
                                        <IconoFinal sx={{fill: '#fff', width: 20, height: 20}}/>
                                    }

                                </IconButton>
                            </InputAdornment>
                        ),
                        disableUnderline: true,
                    },
                    inputLabel: {
                        sx: {marginLeft: -1}
                    }
                } :

                {
                    input: {
                        disableUnderline: true
                    },
                    inputLabel: {
                        sx: {marginLeft: -1}
                    }
                }
            }
            // color={'info'}
            disabled={!editable}
            fullWidth
            size={size}
            label={nombre}
            multiline={lineas > 1} rows={lineas}
            type={type}
            {...register(dato, {required: requerido})}
            error={!!errors[dato]}
            helperText={errors[dato]?.message}

        />
    )

}
export default IngresoTextoBoton